module.exports = __webpack_public_path__ + "static/media/whySales2.4e968707.png";